import type { GoalFormModel } from "web_myplann/Goals/Forms/useGoalForm";
import {
	dateFormatter,
	ISO_DATE_FORMAT,
} from "web_myplann/Shared/Utils/dateFormatters";

export const mapGoalFormToParams = (
	fields: Partial<GoalFormModel>,
): URLSearchParams => {
	const params = new URLSearchParams();
	const set = (key: string, value: string | number | undefined | null) => {
		if (value !== undefined && value !== null) params.set(key, String(value));
	};

	set("category", fields.category);
	set("name", fields.name);
	set("totalValue", fields.totalValue);
	set("ownFunds", fields.ownFunds);
	set("loanAmount", fields.loanAmount);
	set("monthlyRent", fields.monthlyRent);
	set("drawdownMode", fields.drawdownMode);
	if (fields.dueDate)
		params.set("dueDate", dateFormatter(fields.dueDate, ISO_DATE_FORMAT));

	return params;
};
